module.exports = __webpack_public_path__ + "files/dcf0838b3ea30cb59ecd1356f6ec2eaf.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-16x16.png
// module id = 536
// module chunks = 76